import { get, post } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';
import {
    LOGIN_MODAL_RECEIVE,
    LOGIN_MODAL_SHOW,
    LOGIN_MODAL_CONTINUE_WITHOUT_LOGIN,
    LOGIN_MODAL_PREFFERED_ORG_ID,
    LOGIN_MODAL_ERROR,
    LOGIN_MODAL_OPEN_ORGANIZATION_SELECTOR,
    GUID_EMPTY,
} from '../constants';
const api = '/api/loginmodal';

export const checkLogin = (checkForOrganizations = true, callback) => (
    dispatch,
    getState
) => {
    return get(`${api}?checkForOrganizations=${checkForOrganizations}`)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result, callback));
        })
        .catch((ex) => dispatch(catchError(ex, loadError)));
};

export const ensurePageAccess = async (dispatch) => {
    const accessResponse = await dispatch(checkCurrentPageAccess());
    if (accessResponse.LogonIsNeeded) {
        //console.log("LOG IN!");
        return false;
    }
    return true;
};

export const checkCurrentPageAccess = (callback) => (dispatch, getState) => {
    return get(`${api}/checkCurrentPageAccess`)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receivePageAccess(result, callback));
            return result; // Return the result object
        })
        .catch((ex) => {
            dispatch(dispatch(catchError(ex, loadError)));
            return { logonIsNeeded: false }; // Return a default object in case of error
        });
};


export const login = (usr, psw, callback) => (dispatch, getState) => {
    const preferredOrgId = getState().loginModal.preferredOrgId;
    const loginViewModel = {
        loginForm: {
            userName: usr,
            password: psw,
        },
        selectedOrganization:
            !preferredOrgId || preferredOrgId === -1 ? GUID_EMPTY : preferredOrgId,
    };
    return post(api, loginViewModel)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result));
        })
        .catch((ex) => dispatch(dispatch(catchError(ex, loadError))));
};

export const continueWithoutLogin = () => ({
    type: LOGIN_MODAL_CONTINUE_WITHOUT_LOGIN,
    payload: {
        continueWithoutLogin: true,
    },
});

export const setPreferredOrgId = (orgId) => ({
    type: LOGIN_MODAL_PREFFERED_ORG_ID,
    payload: {
        preferredOrgId: orgId,
    },
});

export const showModalLogin = (setStatus = true, preferredOrgId = -1) => ({
    type: LOGIN_MODAL_SHOW,
    payload: {
        preferredOrgId,
        visible: setStatus,
    },
});

export const receivePageAccess = (payload, callback) => (dispatch, getState) => {
    //if (callback) {
    //    callback(result);
    //}
    //alert(JSON.stringify(payload));
    dispatch({
        type: LOGIN_MODAL_RECEIVE,
        payload,
    });
};
export const receive = (payload, callback) => (dispatch, getState) => {
    //if (callback) {
    //    callback(result);
    //}

    dispatch({
        type: LOGIN_MODAL_RECEIVE,
        payload,
    });
};